/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { TransitionLabeledDestinationFromJSON, TransitionLabeledDestinationToJSON, } from './';
export function TransitionYesNoFromJSON(json) {
    return TransitionYesNoFromJSONTyped(json, false);
}
export function TransitionYesNoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'yes': !exists(json, 'yes') ? undefined : TransitionLabeledDestinationFromJSON(json['yes']),
        'no': !exists(json, 'no') ? undefined : TransitionLabeledDestinationFromJSON(json['no']),
    };
}
export function TransitionYesNoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'yes': TransitionLabeledDestinationToJSON(value.yes),
        'no': TransitionLabeledDestinationToJSON(value.no),
    };
}
//# sourceMappingURL=TransitionYesNo.js.map